import React from 'react';
import {doc, getFirestore, setDoc} from 'firebase/firestore'
import {BsShareFill} from 'react-icons/bs'
import {RiHeartLine,RiHeartFill} from 'react-icons/ri'
import {IoIosArrowDown,IoIosArrowUp} from 'react-icons/io'
import './annonceCard.css'
import { useDispatch, useSelector } from 'react-redux';
import { setShowAuthModal } from '../../redux/reducers/navigation';

const AnnonceCard = ({annonce}) => {
    const dispatch = useDispatch()

    const [liked,setLiked] = React.useState(false)
    const [showDetails,setShowDetails] = React.useState(false)

    const currentUser = useSelector(state => state.users.currentUser)

    React.useEffect(()=>{
        if(annonce.likers.includes(currentUser.telephone)){
            setLiked(true)
        }
    },[currentUser.telephone])

    const likeAnnonce = () => {
        if(currentUser.telephone.length){
            setLiked(!liked)

            setDoc(doc(getFirestore(),"annonces",annonce.id),{...annonce,
                likers: annonce.likers.includes(currentUser.telephone)?
                    annonce.likers.filter(item=>item !== currentUser.telephone)
                    :
                    [...annonce.likers,currentUser.telephone]
            })
            .catch(err => setLiked(!liked))
        }else{
            dispatch(setShowAuthModal(true))
        }
    }
    return (
        <div className="annonce-card card shadow pt-1 my-2">
            <img src={annonce.imageUrl} alt=".." />
            {showDetails && (
                <div>
                    <p className="fw-bold p-0 m-0">{annonce.title}</p>
                    <p className="p-0 m-0 fs-90">{annonce.description}</p>
                </div>
            )}
            <div className='ms-auto py-1'>
                {liked ?
                    <RiHeartFill size={22} className='mx-2' onClick={likeAnnonce}/>
                    :
                    <RiHeartLine size={22} className='mx-2' onClick={likeAnnonce}/>
                }
                <a href={'share:'+annonce.imageUrl}>

                <BsShareFill size={22} color='black' className='mx-2'/>
                </a>
                {showDetails ?
                    <IoIosArrowUp size={22} className='mx-2' onClick={()=>setShowDetails(false)}/>
                    :
                    <IoIosArrowDown size={22} className='mx-2' onClick={()=>setShowDetails(true)}/>
                }
            </div>
        </div>
    );
};

export default AnnonceCard;